var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert offline-card d-flex align-items-center mb-0"},[_c('i',{staticClass:"fa-solid fa-wifi mr-3 offline-icon"}),_c('div',[_c('h6',{staticClass:"font-weight-bold mb-0"},[_vm._v("Desconectado")]),_c('p',{staticClass:"mb-0"},[_vm._v("Verifique sua conexão com a Internet")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }